import React from "react";
import './togglelang.css';

interface ToggleProps {
    toggleLang: () => void;
    lang: string;
}

export const LanguageToggle: React.FC<ToggleProps> = ({ toggleLang, lang }) => {
    const label = lang === 'sv'
        ? <p className='category2'>English version</p>
        : <p className='category2'>Svenska version</p>;

    return (
        <div onClick={toggleLang} className="language-toggle-button">
            {label}
        </div>
    );
};
